import { Box, Divider } from '@mui/material'
import { useMessageSource } from 'src/i18n/useMessageSource'
import { ROUTES } from 'src/routing/routes'
import { SettingsIcon } from 'src/shared/icons/Icons'
import { Sidebar, SidebarGroupObject } from 'src/shared/sidebar/Sidebar'
import { S } from 'src/shared/styled/S'

export const AdministrationSidebar = () => {
  const { getMessage } = useMessageSource()

  const routeGroups: SidebarGroupObject[] = [
    {
      groupMessageKey: 'label.administration',
      list: [
        {
          listMessageKey: 'label.navigation.round.management',
          href: ROUTES.RoundManagementIndex.params({}),
          routePath: ROUTES.RoundManagementIndex.path,
        },
        {
          listMessageKey: 'label.navigation.application-type.management',
          href: ROUTES.ApplicationTypeManagementIndex.params({}),
          routePath: ROUTES.ApplicationTypeManagementIndex.path,
        },
        {
          listMessageKey: 'label.navigation.gfch.user.administration',
          href: ROUTES.UserAdministrationIndex.params({}),
          routePath: ROUTES.UserAdministrationIndex.path,
        },
      ],
    },
    {
      groupMessageKey: 'label.configuration',
      list: [
        {
          listMessageKey: 'label.navigation.configuration.features',
          href: ROUTES.FeaturesConfigurationIndex.params({}),
          routePath: ROUTES.FeaturesConfigurationIndex.path,
        },
        {
          listMessageKey: 'label.navigation.configuration.criteria',
          href: ROUTES.CriteriaConfigurationIndex.params({}),
          routePath: ROUTES.CriteriaConfigurationIndex.path,
        },
        {
          listMessageKey: 'label.navigation.configuration.help.instructions',
          href: ROUTES.HelpInstructionsConfigurationIndex.params({}),
          routePath: ROUTES.HelpInstructionsConfigurationIndex.path,
        },
        {
          listMessageKey: 'label.navigation.configuration.milestones',
          href: ROUTES.MilestonesConfigurationIndex.params({}),
          routePath: ROUTES.MilestonesConfigurationIndex.path,
        },
        {
          listMessageKey: 'label.navigation.configuration.principles',
          href: ROUTES.PrinciplesConfigurationIndex.params({}),
          routePath: ROUTES.PrinciplesConfigurationIndex.path,
        },
        {
          listMessageKey: 'label.navigation.configuration.committees',
          href: ROUTES.CommitteesConfigurationIndex.params({}),
          routePath: ROUTES.CommitteesConfigurationIndex.path,
        },
      ],
    },
  ]

  return (
    <>
      <Box>
        <S.ListItem.SidebarHome
          selectable={false}
          to={'/' + ROUTES.RoundManagementIndex.path}
          icon={<SettingsIcon />}
          end
          primary={getMessage('label.administration')}
        />
        <Divider />
      </Box>

      <Sidebar routes={routeGroups} hideDetailedInformation />
    </>
  )
}
